// StatusBanner.tsx
import { m } from "framer-motion";
import { Clock, Moon } from "lucide-react";
import { useIntakeCopy } from "../i18n/useIntakeCopy";
import type { IntakeArtist } from "../types";
import { DUR, EASE_ENTER } from "../motion/tokens";

export function StatusBanner({ artist }: { artist: IntakeArtist }) {
  const { c, fmt } = useIntakeCopy();
  if (artist.status === "open") return null;
  const Icon = artist.status === "waitlist" ? Clock : Moon;
  return (
    <m.div role="status" initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0, transition: { duration: DUR.ui, ease: EASE_ENTER } }}
      className="flex items-start gap-3 rounded-xl border border-[var(--color-warning)]/40 bg-[var(--color-warning)]/10 px-4 py-3 text-sm text-[var(--color-text)]">
      <Icon className="mt-0.5 h-4 w-4 shrink-0 text-[var(--color-warning)]" aria-hidden />
      <span>{fmt(c.banner[artist.status], { artist: artist.name })}</span>
    </m.div>
  );
}
